export default __webpack_public_path__ + "bdbaced092bdf57c31bf1b9ee66cc9db.png";